
import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import {
    Button,
    Card, Flex, Form, Input, Spin, theme,
} from 'antd';
import { useCallback } from 'react';
import {
    Controller, useForm,
} from 'react-hook-form';
import { z } from 'zod';

import { authMutations } from '@/api';
import { LoginPayload } from '@/types';

import { AppLogo } from './AppLogo';
import { VersionOutput } from './VersionOutput';

const loginSchema = z.object({
    login: z.string().min(1, 'Логін обов\'язковий').trim(),
    password: z.string().min(1, 'Пароль обов\'язковий').min(6, 'Мінімум 6 символів'),
});

export const LoginForm = () => {
    const { token } = theme.useToken();

    const { mutate: login, isPending } = useMutation(authMutations.login());

    const { control, handleSubmit, formState: { errors } } = useForm<LoginPayload>({
        resolver: zodResolver(loginSchema),
        defaultValues: {
            login: '',
            password: '',
        },
    });

    const onSubmit = useCallback((values: LoginPayload) => {
        login(values);
    }, [login]);

    return (
        <Card variant="outlined" className="login-form-container">
            <VersionOutput />

            <Flex vertical align="center" style={{
                marginBottom: token.marginLG,
            }}>
                <AppLogo size="large" />
            </Flex>

            <Spin spinning={isPending}>
                <Form
                    layout="vertical"
                    onFinish={handleSubmit(onSubmit)}
                >
                    <Controller
                        name="login"
                        control={control}
                        render={({ field }) => <Form.Item
                            label="Логін або пошта"
                            name={field.name}
                            required
                            validateStatus={errors.login ? 'error' : ''}
                            help={errors.login?.message}
                            style={{ marginBottom: token.marginXL }}
                        >
                            <Input
                                {...field}
                                placeholder="Логін або пошта"
                                disabled={isPending}
                                size="large"
                            />
                        </Form.Item>}
                    />

                    <Controller
                        name="password"
                        control={control}
                        render={({ field }) => <Form.Item
                            label="Пароль"
                            name={field.name}
                            required
                            validateStatus={errors.password ? 'error' : ''}
                            help={errors.password?.message}
                            style={{ marginBottom: token.marginXL }}
                        >
                            <Input.Password
                                {...field}
                                placeholder="Пароль"
                                disabled={isPending}
                                size="large"
                            />
                        </Form.Item>}
                    />

                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={isPending}
                            disabled={isPending}
                            size="large"
                            block
                        >
                            Вхід в систему
                        </Button>
                    </Form.Item>
                </Form>
            </Spin>
        </Card>
    );
};
